import { cloneElement, isValidElement, type ReactElement, type ReactNode, useId } from "react";

export interface FormFieldProps {
  label: string;
  /** Hata metni ŞEMADAN gelir (kriter 7); FormField yalnız gösterir. */
  error?: string;
  hint?: string;
  required?: boolean;
  children: ReactNode;
}

type FieldControlProps = {
  id?: string;
  "aria-invalid"?: boolean;
  "aria-describedby"?: string;
};

export function FormField({ label, error, hint, required, children }: FormFieldProps) {
  const autoId = useId();
  const errorId = `${autoId}-error`;
  const hintId = `${autoId}-hint`;
  const describedBy = error ? errorId : hint ? hintId : undefined;

  let controlId = autoId;
  let control: ReactNode = children;
  if (isValidElement(children)) {
    const element = children as ReactElement<FieldControlProps>;
    controlId = element.props.id ?? autoId;
    control = cloneElement(element, {
      id: controlId,
      "aria-invalid": error ? true : undefined,
      "aria-describedby": describedBy,
    });
  }

  return (
    <div className="flex flex-col gap-1.5">
      {/* Yıldız label DIŞINDA: erişilebilir ad "Ad*" değil "Ad" kalır (getByLabelText). */}
      <span className="text-sm font-medium text-fg-strong">
        <label htmlFor={controlId}>{label}</label>
        {required ? (
          <span aria-hidden="true" className="ml-0.5 text-danger">
            *
          </span>
        ) : null}
      </span>
      {control}
      {hint && !error ? (
        <p id={hintId} className="text-xs text-fg-soft">
          {hint}
        </p>
      ) : null}
      {error ? (
        <p id={errorId} role="alert" className="text-xs text-danger">
          {error}
        </p>
      ) : null}
    </div>
  );
}
